import { API_URLs } from "../../../utilities/API_URLs";
import iAxios from "../../../utilities/axios/axios-setup";
import { Http } from "../../../utilities/axios/http";
import { CustomerPageState } from "./_model";

export const postNewCustomer = async (data: any) => {
  try {
    const r = await iAxios.post(API_URLs.settings.customers.postCustomer, data);
    return r.data;
  } catch (e) {
    return null;
  }
};

export const getCustomerList = async (pageState: CustomerPageState) => {
  const obj: any = { ...pageState, order: null };
  Object.keys(pageState).forEach((key: any) => {
    if (key === "order") {
      obj["order[" + (pageState?.order?.dataKey ?? "") + "]"] =
        pageState?.order?.order;
    } else {
      obj[key] = obj[key]?.toString();
    }
  });
  delete obj["order"];
  try {
    const r = await iAxios.get(
      API_URLs.settings.customers.getCustomerList +
        "?" +
        new URLSearchParams(obj)
    );
    return r?.data;
  } catch (e) {
    return null;
  }
};

export const getCustomerById = async (id: string) => {
  try {
    const r = await iAxios.get(
      API_URLs.settings.customers.getCustomerById?.replace("{id}", id)
    );
    return r.data;
  } catch (e) {
    return null;
  }
};

export const deleteCustomerById = async (id: string) => {
  try {
    const r = await iAxios.delete(
      API_URLs.settings.customers.deleteCustomerById?.replace("{id}", id)
    );
    return r.data;
  } catch (e) {
    return null;
  }
};

export const patchCustomerById = async (id: string, data: any) => {
  try {
    const r = await iAxios.patch(
      API_URLs.settings.customers.patchCustomerById?.replace("{id}", id),
      { ...data, id },
      {
        headers: {
          "Content-Type": "application/merge-patch+json",
        },
      }
    );
    return r.data;
  } catch (e) {
    return null;
  }
};

export const postMedia = async (data: any) => {
  try {
    const r = await iAxios.post(API_URLs.media.post, data);
    return r.data;
  } catch (e) {
    return null;
  }
};

export class CustomerService {
  static getAllCustomer = async (params?: any) => {
    try {
      return await Http.get(
        API_URLs.settings.customers.getCustomerList,
        params
      );
    } catch (error) {
      return error;
    }
  };
  static getAllCustomerForSelect = async (params?: any) => {
    try {
      return await Http.get(
        API_URLs.settings.customers.getCustomerSelect,
        params
      );
    } catch (error) {
      return error;
    }
  };

  static getCustomerCategory = async (params?: any) => {
    try {
      return await Http.get(
        API_URLs.settings.customers.getCustomerCategory,
        params
      );
    } catch (error) {
      return error;
    }
  };
}
